// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2jgEV","rootSuccess":"CompleteLink_rootSuccess__33UUr","rootFailure":"CompleteLink_rootFailure__1BYha","isDisabled":"CompleteLink_isDisabled__2sSmA"};